// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimInt64StringKeyValuePair {
    static getAttributeTypeMap() {
        return ClaimInt64StringKeyValuePair.attributeTypeMap;
    }
}
ClaimInt64StringKeyValuePair.discriminator = undefined;
ClaimInt64StringKeyValuePair.additionalProperties = false;
ClaimInt64StringKeyValuePair.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "number"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=claimInt64StringKeyValuePair.js.map